"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PreformattedEdit;

var _element = require("@wordpress/element");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _i18n = require("@wordpress/i18n");

var _blockEditor = require("@wordpress/block-editor");

/**
 * WordPress dependencies
 */
function PreformattedEdit(_ref) {
  let {
    attributes,
    mergeBlocks,
    setAttributes,
    onRemove,
    style
  } = _ref;
  const {
    content
  } = attributes;
  const blockProps = (0, _blockEditor.useBlockProps)({
    style
  });
  return (0, _element.createElement)(_blockEditor.RichText, (0, _extends2.default)({
    tagName: "pre",
    identifier: "content",
    preserveWhiteSpace: true,
    value: content,
    onChange: nextContent => {
      setAttributes({
        content: nextContent
      });
    },
    onRemove: onRemove,
    "aria-label": (0, _i18n.__)('Preformatted text'),
    placeholder: (0, _i18n.__)('Write preformatted text…'),
    onMerge: mergeBlocks
  }, blockProps, {
    __unstablePastePlainText: true
  }));
}
//# sourceMappingURL=edit.js.map